import icon from "images/icons/icon-filter.svg"

interface Props {
  title: string
}

export default function FilterIcon({ title }: Props) {
  return <span className="svg-icon" title={title} dangerouslySetInnerHTML={{ __html: icon }} />
}
